/**
 * Pages Router utility - bundles all messages for client-side access
 * WARNING: This bundles ALL language files into the client bundle
 * Use getMessages.ts for App Router to avoid client bundling
 */

import deMessages from '@/lang/de.json';
import enMessages from '@/lang/en.json';
import esMessages from '@/lang/es.json';
import frMessages from '@/lang/fr.json';
import itMessages from '@/lang/it.json';
import jaMessages from '@/lang/ja.json';
import koMessages from '@/lang/ko.json';
import plMessages from '@/lang/pl.json';
import ptMessages from '@/lang/pt.json';
import zhMessages from '@/lang/zh.json';

export const localeMessages: Record<string, Record<string, string>> = {
	de: deMessages,
	en: enMessages,
	es: esMessages,
	fr: frMessages,
	ja: jaMessages,
	ko: koMessages,
	pt: ptMessages,
	it: itMessages,
	pl: plMessages,
	zh: zhMessages,
};

/**
 * Synchronous message loading for Pages Router
 * Pre-bundles all messages but provides immediate access
 */
export function getBundledMessages(locale: string): Record<string, string> {
	return localeMessages[locale] || localeMessages.en;
}
